import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import { Snackbar } from "@mui/material";
import {
  Container,
  Wrapper,
  Title,
  Desc,
  ContactForm,
  ContactTitle,
  ContactInputWrapper,
  ContactInput,
  ContactInputMessage,
  ContactButton,
  ErrorMessage,
  GeneralErrorMessage
} from "./ContactStyles";

const Contact = () => {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formValues, setFormValues] = useState({
    from_email: "",
    from_name: "",
    subject: "",
    message: "",
  });
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [showGeneralError, setShowGeneralError] = useState(false);
  const [emailError, setEmailError] = useState("");
  const form = useRef();

  useEffect(() => {
    emailjs.init(process.env.REACT_APP_EMAILJS_USER_ID);
  }, []);

  useEffect(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValidEmail(emailRegex.test(formValues.from_email));
    setEmailError(isValidEmail ? "" : "Invalid email address");
  }, [formValues.from_email, isValidEmail]);

  useEffect(() => {
    setShowGeneralError(!Object.values(formValues).every((value) => value.trim() !== ""));
  }, [formValues]);

  const isFormValid = isValidEmail && Object.values(formValues).every((value) => value.trim() !== "");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        () => {
          setOpen(true);
          form.current.reset();
          setFormValues({ from_email: "", from_name: "", subject: "", message: "" });
          setIsSubmitting(false);
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          setIsSubmitting(false);
        }
      );
  };

  return (
    <Container id="contact">
      <Wrapper>
        <Title>Contact</Title>
        <Desc>Feel free to reach out to me for any questions or opportunities!</Desc>
        <ContactForm ref={form} onSubmit={handleSubmit}>
          <ContactTitle>Email Me 🚀</ContactTitle>
          <ContactInputWrapper>
            <ContactInput
              placeholder="Your Email"
              name="from_email"
              value={formValues.from_email}
              onChange={handleChange}
            />
            {!isValidEmail && <ErrorMessage>{emailError}</ErrorMessage>}
          </ContactInputWrapper>
          <ContactInputWrapper>
            <ContactInput
              placeholder="Your Name"
              name="from_name"
              value={formValues.from_name}
              onChange={handleChange}
            />
          </ContactInputWrapper>
          <ContactInputWrapper>
            <ContactInput
              placeholder="Subject"
              name="subject"
              value={formValues.subject}
              onChange={handleChange}
            />
          </ContactInputWrapper>
          <ContactInputWrapper>
            <ContactInputMessage
              placeholder="Message"
              rows="4"
              name="message"
              value={formValues.message}
              onChange={handleChange}
            />
          </ContactInputWrapper>
          <ContactButton type="submit" value="Send" disabled={!isFormValid || isSubmitting} />
          {showGeneralError && <GeneralErrorMessage>All fields are mandatory!</GeneralErrorMessage>}
        </ContactForm>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message="Email sent successfully!"
        />
      </Wrapper>
    </Container>
  );
};

export default Contact;
